import { DatePipe, formatDate } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import * as moment from "moment-timezone";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DataExportService } from "src/app/_services/dataExportService";
import { InvoiceService } from "src/app/_services/invoice.service";
import { PosService } from "src/app/_services/posService";
import { Invoices } from "../../../_models/table-models";
import { ImpersonationService } from "src/app/_app-core/services/impersonation/impersonation.service";

// JSW-branch-specific: shortcut to JSW's legacy vendor portal ("old vendor portal") for
// detailed invoice payment status. This build deploys ONLY to the JSW application, so the
// link is rendered unconditionally. If this code is ever merged into a shared/multi-tenant
// build, GATE this link behind a JSW tenant check (e.g. authService.getSellerCode() === 'JSW')
// before shipping — all its values are kept here in one place to make that easy.
const INVOICE_PAYMENT_TRACKER = {
  label: "Invoice Payment Tracker",
  url: "https://vendorportal.jsw.in/VENDOR/viewHome.action",
  tooltip:
    "Access detailed payment status for all submitted invoices in old vendor portal",
};

@Component({
  selector: "app-invoices",
  templateUrl: "./invoices.component.html",
  styleUrls: ["./invoices.component.scss"],
})
export class InvoicesComponent implements OnInit {
  searchTerm: string = "";
  invoices: Invoices[] = [];
  allInvoices: Invoices[] = [];
  responseData: any;
  isError: any;
  isEmpty = false;
  loading = true;
  fetching = true;
  vendorError = false;
  invoiceError = false;
  displayName: any;
  page = 1;
  pageSize = 10;
  collectionSize: any;
  invs: any;
  tempDataset = [];
  sessionExpired = false;
  errorMsg = "";
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  filterBy: any = "barcodeRegex";
  canSubmitNonPo = false;
  canSubmitLogistics = false;
  vendorData: any;
  tableData: any;
  gstExist: boolean;
  checkproperty: string;
  isSelected = false;
  invoiceSelected = [];
  impersonate;
  // JSW-branch-specific external link (see INVOICE_PAYMENT_TRACKER above).
  invoicePaymentTracker = INVOICE_PAYMENT_TRACKER;
  showGrnNoFilter = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private authService: AuthService,
    private invoiceService: InvoiceService,
    private exportService: DataExportService,
    private cdref: ChangeDetectorRef,
    private datePipe: DatePipe,
    private posService: PosService,
    @Inject(LOCALE_ID) public locale: string,
    public imp: ImpersonationService
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  cleanRoute(path: any) {
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onSelectChanges(selectedInvoice) {
    if (selectedInvoice.selected) {
      this.invs.forEach((invoice) => {
        if ((invoice.poNo !== selectedInvoice.poNo || invoice.poNo === null) && invoice !== selectedInvoice) {
          invoice.selected = false;
        }
      });

      if (selectedInvoice.poNo === null || selectedInvoice.poNo !== this.invoiceSelected[0]?.poNo) {
        // Clear selectedInvoices array if PO number is null or different
        this.invoiceSelected = [];
      }

      const existingInvoice = this.invoiceSelected.find((invoice) => invoice.invoice_number === selectedInvoice.invoice_number);
      if (!existingInvoice) {
        // Add new selected invoice
        this.invoiceSelected.push(selectedInvoice);
        if (this.invoiceSelected.length !== 0) {
          this.isSelected = true;
        }
      }
    } else {
      const existingInvoice = this.invoiceSelected.find((invoice) => invoice.invoice_number === selectedInvoice.invoice_number);
      if (!existingInvoice) {
        // Remove deselected invoice from the selectedInvoices array
        const index = this.invoiceSelected.findIndex((invoice) => invoice.invoice_number === selectedInvoice.invoice_number);
        if (index !== -1) {
          this.invoiceSelected.splice(index, 1);
        }
      }
    }
  }

  sendInvoice() {
    localStorage.setItem("selectionType", "invoice");
    localStorage.setItem("pods", JSON.stringify([this.invoiceSelected]));
    if (this.invoiceSelected[0].poNo) {
      localStorage.setItem("invoiceType", "poInvoice");
      localStorage.setItem("invoiceList", JSON.stringify(this.invoiceSelected));
    this.router.navigate(["/upload-credit-note", this.invoiceSelected[0]?.poNo]);
    } else {
      localStorage.setItem("invoiceType", "nonPoInvoice");
      localStorage.setItem("invoiceList", JSON.stringify(this.invoiceSelected));
    this.router.navigate(["/upload-credit-note", this.invoiceSelected[0]?.barcode]);
    }
    // localStorage.setItem("invoiceList", JSON.stringify(this.invoiceSelected));
    // this.router.navigate(["/upload-credit-note", this.invoiceSelected[0]?.poNo]);
  }

  fetchVendorData() {
    const vendorData = {
      sellerCode: localStorage.getItem("vendorCode"),
      session: { sessionId: localStorage.getItem("eippSession") },
    };

    this.authService.fetchVendorMasterData(vendorData).subscribe(
      (res) => {
        this.fetching = false;
        this.responseData = res;
        if (this.responseData.success) {
          this.vendorData = this.responseData.data.supplier;

          if (this.vendorData.logistics_flag === "TRUE") {
            this.canSubmitLogistics = true;
          } else {
            this.canSubmitLogistics = false;
          }

          if (this.vendorData.non_po_flag === "TRUE") {
            this.canSubmitNonPo = true;
          } else {
            this.canSubmitNonPo = false;
          }
        } else {
          this.isError = true;
          this.fetching = false;
          this.isEmpty=true
          // if (this.responseData.msgCode === "DEFAULT_BLANK") {
          //   this.vendorError = true;
          //   this.errorMsg = this.responseData.msg;
          // } else {
          //   this.isEmpty = true;
          // }
        }
      },
      (error) => {
        this.fetching = false;
        this.isError = true;
        console.log(error);
      }
    );
  }

  fetchInvoices() {
    this.loading = true;
    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: this.pageSize,
      pageNo: this.page,
      filters: [
        {
          key: "docType",
          value: "APINV",
        },
        {
          key: "supplierCodesToRestrict",
          value: localStorage.getItem("vendorCode"),
        },
      ],
      sellercode: this.authService.getSellerCode(),
      isExport: false,
      linkFilters: [],
      isAP: true,
      isPOD: true,
    };

    if (this.searchTerm && this.searchTerm.trim() !== "") {
      const trimmed = this.searchTerm.trim();
      const filterValue =
        this.filterBy === "statusRegex" ? this.uppercaseStatusForQuery(trimmed) : trimmed;
      userData.filters.push({
        key: this.filterBy,
        value: filterValue,
      });
    }

    this.posService.fetchPurchaseOrders(userData).subscribe(
      (res) => {
        this.responseData = res;
        this.fetching = false;
        if (this.responseData.code === 200 && this.responseData.success) {
          this.invoices = this.responseData.data.list.map((item: any) => {
            let currentStatus = item.status;
            let statusReason = "";
            let rejections = { rej1: null, rej2: null };

            if (item.gpStatus && item.gpStatus.statusHistory && item.gpStatus.statusHistory.length > 0) {
              const latestStatus = item.gpStatus.statusHistory[item.gpStatus.statusHistory.length - 1];
              currentStatus = latestStatus.status;

              if (latestStatus.meta && latestStatus.meta.status_reason) {
                statusReason = latestStatus.meta.status_reason;
              }

              const rejectedStatuses = item.gpStatus.statusHistory.filter((status: any) => status.status === "Rejected" || status.status === "rejected");

              if (rejectedStatuses.length > 0) {
                rejections.rej1 = {
                  reason: rejectedStatuses[0].meta?.status_reason || "",
                };
                if (rejectedStatuses.length > 1) {
                  rejections.rej2 = {
                    reason: rejectedStatuses[1].meta?.status_reason || "",
                  };
                }
              }
            }
            let paymentDueDate = "";
            if (item.dueDate) {
              const gmtMoment = moment(item.dueDate);
              const istMoment = gmtMoment.tz("Asia/Kolkata");
              paymentDueDate = istMoment.format("DD/MM/yyyy");
            }

            const row: any = {
              invoice_number: item.docNo,
              barcode: item.barcode,
              poNo: item.poNo,
              invoice_amount: item.docAmount,
              po_currency: item.currCode,
              status: currentStatus,
              payment_due_date_iso: paymentDueDate,
              status_reason: statusReason,
              rejections: rejections,
              reference_details: {
                docType: item.erpDocType || "",
              },
              selected: false,
              cmpCode: item.cmpCode || "",
              purchaseOrg: item.purchaseOrg || "",
              erpDocType: item.erpDocType || "",
              docDetail: item.docDetail,
            };

            const currGstStatus = item.gpStatus?.currStatus?.status;
            if (currGstStatus === "Posted" || currGstStatus === "POSTED") {
              row.gst_reconciled = "TRUE";
            } else if (item.gst_reconciled !== undefined && item.gst_reconciled !== null && item.gst_reconciled !== "") {
              const g = item.gst_reconciled;
              if (g === true || g === "TRUE" || g === "true") {
                row.gst_reconciled = "TRUE";
              } else if (g === false || g === "FALSE" || g === "false") {
                row.gst_reconciled = "FALSE";
              } else if (g === "UNKNOWN") {
                row.gst_reconciled = "UNKNOWN";
              }
            }

            return row;
          });
          if (this.invoices.length <= 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          this.collectionSize = this.responseData.data.noOfRecords || this.invoices.length;
          this.refreshInvoices();
          this.loading = false;
        } else {
          this.loading = false;
          this.isEmpty = true;
          // if (this.responseData.msgCode === "DEFAULT_BLANK") {
          //   this.invoiceError = true;
          //   this.errorMsg = this.responseData.message || this.responseData.msg;
          // } else {
            
          // }
        }
      },
      (error) => {
        this.loading = false;
        if (error.status === 401 || error.status === 403) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.setShowGrnNoFilter();

    this.fetchInvoices();
    this.fetchVendorData();

    if (localStorage.getItem("impersonation") === null || localStorage.getItem("impersonation") === "") {
      this.impersonate = "false";
    } else {
      this.impersonate = localStorage.getItem("impersonation");
    }
  }

  exportToExcel() {
    const date = new Date();

    const fileName = (this.displayName = localStorage.getItem("vendorCode")) + "_Invoices_Table_" + formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

    this.tableData = this.invoices;

    const cols = [
      {
        name: "Invoice No",
        colKey: "invoice_number",
      },
      {
        name: "Barcode No",
        colKey: "barcode",
      },
      {
        name: "PO No",
        colKey: "poNo",
      },
      {
        name: "Invoice Amount",
        colKey: "invoice_amount",
      },
      {
        name: "Currency",
        colKey: "po_currency",
      },
      {
        name: "Current Status",
        colKey: "status",
      },
      {
        name: "Payment Due Date",
        colKey: "payment_due_date",
      },
      {
        name: "GST Reconciled",
        colKey: "gst_reconciled",
      },
    ];

    this.exportService.exportToExcel(this.tableData, cols, fileName);
  }

  accountLogout() {
    localStorage.clear();
    this.router.navigateByUrl("/");
    // const userData = {
    //     session: { sessionId: localStorage.getItem("eippSession") },
    // };
    // this.authService.logOut(userData).subscribe(
    //     (res) => {
    //         const responseData: any = res;
    //         if (responseData.status === "ok") {
    //             localStorage.clear();
    //             this.router.navigateByUrl("/");
    //         }
    //     },
    //     (error) => {
    //         console.log(error);
    //         localStorage.clear();
    //         this.router.navigateByUrl("/");
    //     }
    // );
  }

  refreshInvoices() {
    let sortedInvoices = this.invoices.sort((a, b) => (a.creation_date_sys > b.creation_date_sys ? 1 : -1));

    sortedInvoices.forEach((e) => {
      if (this.checkObjectKeyExist(e, "rejections", "rej1") === undefined) {
        Object.assign(e, { rejection1: false });
      } else {
        Object.assign(e, { rejection1: true });
      }

      if (this.checkObjectKeyExist(e, "rejections", "rej2") === undefined) {
        Object.assign(e, { rejection2: false });
      } else {
        Object.assign(e, { rejection2: true });
      }

      if (this.checkObjectKeyExist(e, "gst_reconciled") === undefined) {
        Object.assign(e, { gst_exist: false });
      } else {
        Object.assign(e, { gst_exist: true });
      }
    });

    this.invs = sortedInvoices.map((po, i) => ({ id: i + 1, ...po }));
  }

  orderBy(prop: string) {
    return this.invs.sort((a, b) => (a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1));
  }

  onFilter(option: any) {
    this.filterBy = option.target.value;
    if (this.searchTerm && this.searchTerm.trim() !== "") {
      this.page = 1;
      this.fetchInvoices();
    }
  }

  onSearch(event: KeyboardEvent) {
    this.searchTerm = (event.target as HTMLInputElement).value;
    this.page = 1;
    this.fetchInvoices();
  }

  checkObjectKeyExist(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj);
  }

  /** Uppercases every character of the status search text for the Current Status API query. */
  private uppercaseStatusForQuery(value: string): string {
    if (!value) {
      return value;
    }
    return value.trim().toUpperCase();
  }

  setShowGrnNoFilter() {
    const currentUser: any = this.authService.getCurrentUser();
    this.showGrnNoFilter = currentUser?.uiConfig?.showInvoiceGrnNoFilter === true;
  }
}
